import { Dataset, GridRow } from '../../../../types/types';

export const mergeSelectedRowsFilter = (
  dataset: Dataset,
  activeFilters: Record<string, unknown> | null,
  selectedRows: GridRow[] | undefined
): Record<string, unknown> | null => {
  if (!selectedRows?.length) {
    return activeFilters;
  }

  const idItem: string | undefined = dataset.idItem;

  // Without a real idItem the backend can't be asked by id; caller narrows by loaded position.
  if (!idItem) {
    return activeFilters;
  }

  const selectedIds = selectedRows
    .map((row) => row[idItem])
    .filter((id) => id !== undefined && id !== null);

  if (selectedIds.length === 0) {
    return {
      ...(activeFilters ?? {}),
      [idItem]: { in: [] },
    };
  }

  // Selected-row export must ask the backend by idItem instead of trusting only loaded row data.
  return {
    ...(activeFilters ?? {}),
    [idItem]: { in: selectedIds },
  };
};
